var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.activeSorts > 0 ? 'warning' : 'primary'},on:{"click":_vm.trier}},[_c('b-icon-sort-down'),_c('span',{staticClass:"d-none d-md-inline"},[_vm._v(" Tris")]),(_vm.activeSorts > 0)?_c('span',[_vm._v(" ("+_vm._s(_vm.activeSorts)+")")]):_vm._e(),_c('SortsDialog',{ref:"sortsDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }